import SideBarLayout from "src/v2/layout/side-bar-layout"
import React, {useEffect, useState} from "react"
import {Box, Grid, Paper} from "@mui/material"
import CadastroLoteUpload from "./components/cadastro-lote-upload"
import CadastroLoteTable from "./components/cadastro-lote-table"
import MotorWorkflowService from "../../../../services/motor-workflow-service"
import {cadastroLoteColumnsTable} from "./components/cadastro-lote-columns-table"
import {dispatchSnackbar} from "src/v2/components/SnackBar/snackbar-bus"

const MODELO_PROJETAR = "MC_EmissaoRendaFixaParametros"

export const MotorCadastroLotePage = () => {
    const pageTitle = "Cadastro em Lote"
    const service = new MotorWorkflowService()
    const [loading, setLoading] = useState(false)
    const [rows, setRows] = useState([])
    const [modelFile, setModelFile] = useState("")
    const [projetar, setProjetar] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)
    const [workflowsType, setWorkflowsType] = useState([])

    useEffect(() => {
        loadWorkflows()
        loadWorkflowsType()
    }, [])

    const handleEnviar = async (payload) => {
        if (!payload?.model) {
            dispatchSnackbar("Selecione o modelo do arquivo antes de enviar", "warning")
            return false
        }
        try {
            setLoadingPage(true)
            const response = await service.postUploadCadastroLote(payload)

            const data = response?.data ?? response?.body ?? response
            const statusRotina = data?.status_code ?? data?.status
            const erroRotina = data?.error

            if (erroRotina || statusRotina >= 400) {
                console.error("Erro na rotina de cadastro em lote:", data)
                dispatchSnackbar("Não foi possível enviar o arquivo", "error")

                return false
            }

            console.log("Arquivo enviado com sucesso")
            dispatchSnackbar("Arquivo enviado com sucesso", "success")

            return true
        } catch (error) {
            console.error("Erro ao enviar cadastro em lote:", error)
            dispatchSnackbar("Não foi possível enviar o arquivo", "error")

            return false
        } finally {
            setLoadingPage(false)
        }
    }

    const downloadReport = (id) => {
        setLoadingPage(true)
        service.downloadReport(id)
            .then((response) => {
                const blob = response.body
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement("a")

                link.href = url
                link.setAttribute("download", "relatorio_cadastro_lote.csv")

                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(url)
            })
            .catch((error) => {
                console.log(error)
                dispatchSnackbar("Erro ao recuperar o relatório", "error")
            })
            .finally(() => setLoadingPage(false))
    }

    const columns = cadastroLoteColumnsTable(downloadReport)

    const loadWorkflows = () => {
        setLoading(true)
        service.getWorkflows()
            .then((response) => {
                const {body: {results}} = response
                setRows(results)
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const loadWorkflowsType = () => {
        setLoading(true)
        service.getWorkflowsType()
            .then((response) => {
                const {body: {models}} = response
                setWorkflowsType(models)
            })
            .catch((error) => {
                console.log(error)
                dispatchSnackbar("Erro ao carregar os tipos de modelos", "error")
            }).finally(() => setLoading(false))
    }

    return (
        <SideBarLayout
            title={pageTitle}
            header={true}
            loading={loadingPage}
            headerTitle="Cadastro em Lote"
            headerImage={"/background/eventos_headers.jpg"}
            headerPosition={"1% 41%"}
        >
            <Grid item xs={10} md={3}>
                <Paper sx={{p: 3, borderRadius: 0, mb: 2, mt: -2}}>
                    <Box
                        sx={{
                            flex: 1,
                            overflowX: "auto",
                            width: "100%",
                            display: "block",
                        }}
                    >
                        <CadastroLoteUpload
                            modelFile={modelFile}
                            setModelFile={setModelFile}
                            projetar={projetar}
                            setProjetar={setProjetar}
                            modelosArquivo={workflowsType}
                            modeloProjetar={MODELO_PROJETAR}
                            onSend={handleEnviar}
                        />
                    </Box>
                </Paper>
            </Grid>

            <Grid item xs={12} md={3}>
                <Paper sx={{p: 3, borderRadius: 0}}>
                    <Box
                        sx={{
                            flex: 1,
                            overflowX: "auto",
                            width: "100%",
                            display: "block",
                        }}
                    >
                        <CadastroLoteTable
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            onReload={() => loadWorkflows()}
                        />
                    </Box>
                </Paper>
            </Grid>
        </SideBarLayout>
    )
}

export default MotorCadastroLotePage